import { render, staticRenderFns } from "./LandingComunionES.vue?vue&type=template&id=55663845&scoped=true"
import script from "./LandingComunionES.vue?vue&type=script&lang=js"
export * from "./LandingComunionES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55663845",
  null
  
)

export default component.exports